import * as React from 'react';
import useConversionPixel from './useConversionPixel';
import useTtdSettings from './useTtdSettings';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';

export default function useTrackBookingStarted(
    gaEventName?: string,
): () => void {
    const renderPixel = useConversionPixel();
    const { startBookingEventId } = useTtdSettings();
    const { trackWithAnyGoogleAnalytics } = useGoogleAnalytics();

    return React.useCallback(() => {
        if (gaEventName) {
            trackWithAnyGoogleAnalytics(false, 'event', gaEventName);
        }

        if (startBookingEventId) {
            renderPixel({
                ct: startBookingEventId,
                alt: 'ttd booking started',
            });
        }
    }, [
        startBookingEventId,
        renderPixel,
        gaEventName,
        trackWithAnyGoogleAnalytics,
    ]);
}
